(function () {
    'use strict';

    angular.module('asys')
        .controller('FehlerSeiteController', FehlerSeiteController);

    FehlerSeiteController.$inject = [
        '$scope',
        '$log',
        '$stateParams',
        'AppConfig',
        'AlertService',
        'IntegrationService',
        'NavigationService',
        'MiscUtilsService'
    ];
    function FehlerSeiteController($scope, $log, $stateParams, AppConfig, AlertService, IntegrationService, NavigationService, MiscUtilsService) {
        var vm = this;

        $log.debug('FehlerSeiteController', vm);

        vm.AlertService = AlertService;
        vm.isBlockLinksSichtbar = isBlockLinksSichtbar;

        activate();

        function activate() {
            vm.isTokenLogin = IntegrationService.getIntegrationParams().isTokenLogin;
            vm.urlHomepage = AppConfig.APP.urls.homepage;
            vm.urlKundenportal = AppConfig.APP.urls.kundenportal;
            vm.urlWartungsarbeitenImage = AppConfig.APP.urls.wartungsarbeitenImage;
            vm.subtyp = IntegrationService.getIntegrationParams().subtyp;
            vm.isAppModus = MiscUtilsService.isAppModus();

            vm.message = $stateParams.message;
            vm.linksConfig = $stateParams.links;

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                vm.cssClassMainActive = AppConfig.APP.cssClassMainWidthContainer;
            });
            NavigationService.hideAll(true);
        }

        function isBlockLinksSichtbar() {
            return (
                !vm.isAppModus ||
                vm.isTokenLogin
            );
        }
    }
})();
